import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let LayoutMobile = class LayoutMobile extends Vue {
};
LayoutMobile = __decorate([
    Component
], LayoutMobile);
export default LayoutMobile;
